import { CdkMenuModule } from '@angular/cdk/menu';
import { AsyncPipe, DatePipe, KeyValuePipe, NgClass, NgForOf, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FwAlertModule, FwButtonModule, FwChipModule, FwDialogsModule, FwFormHeadingModule, FwIconButtonModule, FwIconModule, FwLayoutsModule, FwMenuModule, FwProgressModule, FwSectionHeadingModule, FwSelectMenuModule, FwTooltipModule, FwTextInputModule, FwTableModule, FwAvatarModule } from '@flywheel-io/vision';

import { AddDataDialogAlert } from './add-data-dialog/add-data-dialog-alert/add-data-dialog-alert.component';
import { AddDataDialog } from './add-data-dialog/add-data-dialog.component';
import { ConfirmImportDialog } from './confirm-import-dialog/confirm-import-dialog.component';
import { ConflictFilesComponent } from './conflict-files/conflict-files.component';
import { ImportDetailsDialog } from './import-details-dialog/import-details-dialog.component';
import { ImportReportDialog } from './import-report-dialog/import-report-dialog.component';
import { FileImgPipe } from './local-imports/file-img.pipe';
import { LocalImportProgressCardComponent } from './local-imports/local-import-progress-card/local-import-progress-card.component';
import { LocalImportTableFileRow } from './local-imports/local-import-table-file-row/local-import-table-file-row.component';
import { LocalImportTableFolderRow } from './local-imports/local-import-table-folder-row/local-import-table-folder-row.component';
import { LocalImportDialogTable } from './local-imports/local-import-table/local-import-table.component';
import { LocalImport } from './local-imports/local-import.component';
import { MaterialModule } from '../material.module';
import { PipesModule } from '../shared/pipes.module';
import { SharedModule } from '../shared/shared.module';
import { XferModule } from '../xfer/xfer.module';

@NgModule({
  imports: [
    AsyncPipe,
    CdkMenuModule,
    DatePipe,
    FormsModule,
    FwAlertModule,
    FwAvatarModule,
    FwButtonModule,
    FwChipModule,
    FwDialogsModule,
    FwFormHeadingModule,
    FwIconButtonModule,
    FwIconModule,
    FwLayoutsModule,
    FwMenuModule,
    FwProgressModule,
    FwSectionHeadingModule,
    FwSelectMenuModule,
    FwTableModule,
    FwTextInputModule,
    FwTooltipModule,
    KeyValuePipe,
    MaterialModule,
    NgClass,
    NgForOf,
    NgIf,
    NgSwitch,
    NgSwitchCase,
    NgSwitchDefault,
    PipesModule,
    ReactiveFormsModule,
    SharedModule,
    TitleCasePipe,
    XferModule,
  ],
  declarations: [
    AddDataDialog,
    AddDataDialogAlert,
    ConfirmImportDialog,
    ConflictFilesComponent,
    FileImgPipe,
    ImportDetailsDialog,
    ImportReportDialog,
    LocalImport,
    LocalImportTableFileRow,
    LocalImportDialogTable,
    LocalImportProgressCardComponent,
    LocalImportTableFolderRow,
  ],
  exports: [AddDataDialog, ConflictFilesComponent],
})
export class ProjectsImportsModule { }


